"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TenantStatusEnum = exports.TenantPropertiesTypeEnum = exports.TenantCredentialsTargetHostEnum = exports.FilterTenantPropertiesEnum = exports.TdxTenantStatusEnum = exports.TdxSearchOperatorEnum = exports.SortableAndSearchableTenantModelPropertiesEnum = exports.ScreeningStatusEnum = exports.P44Roles = exports.PurposeEnum = exports.PaginationSortEnum = exports.NotificationTypeEnum = exports.GenesisEnum = exports.CarrierNetworkRolesEnum = void 0;
var CarrierNetworkRolesEnum;
(function (CarrierNetworkRolesEnum) {
    CarrierNetworkRolesEnum["CARRIER"] = "CARRIER";
    CarrierNetworkRolesEnum["SHIPPER"] = "SHIPPER";
})(CarrierNetworkRolesEnum = exports.CarrierNetworkRolesEnum || (exports.CarrierNetworkRolesEnum = {}));
var GenesisEnum;
(function (GenesisEnum) {
    GenesisEnum["ADMIN_CREATE"] = "ADMIN_CREATE";
    GenesisEnum["EVERGREEN_SIGN_UP"] = "EVERGREEN_SIGN_UP";
    GenesisEnum["INVITED_SIGN_UP"] = "INVITED_SIGN_UP";
    GenesisEnum["LEGACY"] = "LEGACY";
    GenesisEnum["UNINVITED_SIGN_UP"] = "UNINVITED_SIGN_UP";
})(GenesisEnum = exports.GenesisEnum || (exports.GenesisEnum = {}));
var NotificationTypeEnum;
(function (NotificationTypeEnum) {
    NotificationTypeEnum["CARRIER"] = "CARRIER";
    NotificationTypeEnum["INTEGRATOR"] = "INTEGRATOR";
    NotificationTypeEnum["NONE"] = "NONE";
})(NotificationTypeEnum = exports.NotificationTypeEnum || (exports.NotificationTypeEnum = {}));
var PaginationSortEnum;
(function (PaginationSortEnum) {
    PaginationSortEnum["ASC"] = "ASC";
    PaginationSortEnum["DESC"] = "DESC";
})(PaginationSortEnum = exports.PaginationSortEnum || (exports.PaginationSortEnum = {}));
var PurposeEnum;
(function (PurposeEnum) {
    PurposeEnum["DEMO"] = "DEMO";
    PurposeEnum["PROOF_OF_CONCEPT"] = "PROOF_OF_CONCEPT";
    PurposeEnum["INTERNAL_TEST"] = "INTERNAL_TEST";
    PurposeEnum["TEST"] = "TEST";
    PurposeEnum["PRODUCTION"] = "PRODUCTION";
    PurposeEnum["ARCHIVED"] = "ARCHIVED";
    PurposeEnum["INTERNAL_INFRASTRUCTURE"] = "INTERNAL_INFRASTRUCTURE";
})(PurposeEnum = exports.PurposeEnum || (exports.PurposeEnum = {}));
var P44Roles;
(function (P44Roles) {
    P44Roles["ROLE_P44ADMIN"] = "ROLE_P44ADMIN";
})(P44Roles = exports.P44Roles || (exports.P44Roles = {}));
var ScreeningStatusEnum;
(function (ScreeningStatusEnum) {
    ScreeningStatusEnum["SCREENED_BY_INVITATION"] = "SCREENED_BY_INVITATION";
    ScreeningStatusEnum["SCREENED_LEGACY"] = "SCREENED_LEGACY";
    ScreeningStatusEnum["SCREENED_MANUAL"] = "SCREENED_MANUAL";
    ScreeningStatusEnum["UNSCREENED"] = "UNSCREENED";
})(ScreeningStatusEnum = exports.ScreeningStatusEnum || (exports.ScreeningStatusEnum = {}));
var SortableAndSearchableTenantModelPropertiesEnum;
(function (SortableAndSearchableTenantModelPropertiesEnum) {
    SortableAndSearchableTenantModelPropertiesEnum["ADDRESS1"] = "address1";
    SortableAndSearchableTenantModelPropertiesEnum["ADDRESS2"] = "address2";
    SortableAndSearchableTenantModelPropertiesEnum["CARRIER_NETWORK_ROLES"] = "carrierNetworkRoles";
    SortableAndSearchableTenantModelPropertiesEnum["CONTACT_EMAIL"] = "contactEmail";
    SortableAndSearchableTenantModelPropertiesEnum["COUNTRY"] = "country";
    SortableAndSearchableTenantModelPropertiesEnum["DOT_NUMBER"] = "dotNumber";
    SortableAndSearchableTenantModelPropertiesEnum["GH_CARRIER_ID"] = "ghCarrierId";
    SortableAndSearchableTenantModelPropertiesEnum["MC_NUMBER"] = "mcNumber";
    SortableAndSearchableTenantModelPropertiesEnum["NAME"] = "name";
    SortableAndSearchableTenantModelPropertiesEnum["PROVIDER"] = "provider";
    SortableAndSearchableTenantModelPropertiesEnum["SCAC"] = "scac";
    SortableAndSearchableTenantModelPropertiesEnum["SUBSCRIBER"] = "subscriber";
    SortableAndSearchableTenantModelPropertiesEnum["TENANT_ID"] = "tenantId";
    SortableAndSearchableTenantModelPropertiesEnum["TENANT_UUID"] = "tenantUuid";
    SortableAndSearchableTenantModelPropertiesEnum["VAT_NO"] = "vatNo";
    SortableAndSearchableTenantModelPropertiesEnum["PURPOSE"] = "purpose";
    SortableAndSearchableTenantModelPropertiesEnum["SALESFORCE_ACCOUNT_ID"] = "salesforceAccountId";
})(SortableAndSearchableTenantModelPropertiesEnum = exports.SortableAndSearchableTenantModelPropertiesEnum || (exports.SortableAndSearchableTenantModelPropertiesEnum = {}));
var TdxSearchOperatorEnum;
(function (TdxSearchOperatorEnum) {
    TdxSearchOperatorEnum["LIKE"] = "like";
    TdxSearchOperatorEnum["EQUALS"] = "=";
})(TdxSearchOperatorEnum = exports.TdxSearchOperatorEnum || (exports.TdxSearchOperatorEnum = {}));
var TdxTenantStatusEnum;
(function (TdxTenantStatusEnum) {
    TdxTenantStatusEnum["ASSETS_AVAILABLE"] = "ASSETS_AVAILABLE";
    TdxTenantStatusEnum["CARRIER_UNRESPONSIVE"] = "CARRIER_UNRESPONSIVE";
    TdxTenantStatusEnum["CREATED"] = "CREATED";
    TdxTenantStatusEnum["NO_TCC"] = "NO_TCC";
    TdxTenantStatusEnum["TECHNICAL_EXCEPTION"] = "TECHNICAL_EXCEPTION";
    TdxTenantStatusEnum["UNKNOWN_DEVICE"] = "UNKNOWN_DEVICE";
})(TdxTenantStatusEnum = exports.TdxTenantStatusEnum || (exports.TdxTenantStatusEnum = {}));
var FilterTenantPropertiesEnum;
(function (FilterTenantPropertiesEnum) {
    FilterTenantPropertiesEnum["ADDRESS2"] = "address2";
    FilterTenantPropertiesEnum["ALL"] = "ALL";
    FilterTenantPropertiesEnum["CARRIER_NETWORK_ROLES"] = "carrierNetworkRoles";
    FilterTenantPropertiesEnum["CONTACT_EMAIL"] = "contactEmail";
    FilterTenantPropertiesEnum["COUNTRY"] = "country";
    FilterTenantPropertiesEnum["DOT_NUMBER"] = "dotNumber";
    FilterTenantPropertiesEnum["USER_EMAIL_OR_USER_LAKE_ID"] = "user email or user lakeId";
    FilterTenantPropertiesEnum["GH_CARRIER_ID"] = "ghCarrierId";
    FilterTenantPropertiesEnum["MC_NUMBER"] = "mcNumber";
    FilterTenantPropertiesEnum["NAME"] = "name";
    FilterTenantPropertiesEnum["PROVIDER"] = "provider";
    FilterTenantPropertiesEnum["SCAC"] = "scac";
    FilterTenantPropertiesEnum["SUBSCRIBER"] = "subscriber";
    FilterTenantPropertiesEnum["TENANT_ID"] = "tenantId";
    FilterTenantPropertiesEnum["TENANT_UUID"] = "tenantUuid";
    FilterTenantPropertiesEnum["VAT_NO"] = "vatNo";
    FilterTenantPropertiesEnum["PURPOSE"] = "purpose";
    FilterTenantPropertiesEnum["SALESFORCE_ACCOUNT_ID"] = "salesforceAccountId";
})(FilterTenantPropertiesEnum = exports.FilterTenantPropertiesEnum || (exports.FilterTenantPropertiesEnum = {}));
var TenantCredentialsTargetHostEnum;
(function (TenantCredentialsTargetHostEnum) {
    TenantCredentialsTargetHostEnum["QA_INTEGRATION"] = "na12.api.qa-integration.p-44.com";
    TenantCredentialsTargetHostEnum["QA_STAGE"] = "na12.api.qa-stage.p-44.com";
    TenantCredentialsTargetHostEnum["SANDBOX"] = "na12.api.sandbox.p-44.com";
    TenantCredentialsTargetHostEnum["PROD"] = "na12.api.project44.com";
    TenantCredentialsTargetHostEnum["PROD_EU"] = "eu12.api.project44.com";
})(TenantCredentialsTargetHostEnum = exports.TenantCredentialsTargetHostEnum || (exports.TenantCredentialsTargetHostEnum = {}));
var TenantPropertiesTypeEnum;
(function (TenantPropertiesTypeEnum) {
    TenantPropertiesTypeEnum["Boolean"] = "Boolean";
    TenantPropertiesTypeEnum["Double"] = "Double";
    TenantPropertiesTypeEnum["Float"] = "Float";
    TenantPropertiesTypeEnum["Integer"] = "Integer";
    TenantPropertiesTypeEnum["Long"] = "Long";
    TenantPropertiesTypeEnum["String"] = "String";
})(TenantPropertiesTypeEnum = exports.TenantPropertiesTypeEnum || (exports.TenantPropertiesTypeEnum = {}));
var TenantStatusEnum;
(function (TenantStatusEnum) {
    TenantStatusEnum["ACTIVE_STATUS"] = "active";
    TenantStatusEnum["DELETED_STATUS"] = "deleted";
})(TenantStatusEnum = exports.TenantStatusEnum || (exports.TenantStatusEnum = {}));
